import { LockKeyhole } from 'lucide-react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { AppLayout } from '../../components/layout/AppLayout'
import type { Role } from '../../types/domain'
import { useAuth } from './auth-context'
import { hasAnyPermission, type PermissionKey } from './permissions'

export function RequireSession() {
  const { state, user } = useAuth()
  const location = useLocation()
  if (state === 'loading') return <main className="center-state" role="status">Recuperando sessão segura...</main>
  if (state !== 'authenticated' || !user) return <Navigate replace to="/login" state={{ from: location.pathname }} />
  return <AppLayout />
}

export function RequireRole({ allowed }: { allowed: Role[] }) {
  const { user } = useAuth()
  if (!user || !allowed.includes(user.profile.role)) return <AccessDenied />
  return <Outlet />
}

export function RequirePermission({ anyOf }: { anyOf: readonly PermissionKey[] }) {
  const { user } = useAuth()
  if (!hasAnyPermission(user, anyOf)) return <AccessDenied />
  return <Outlet />
}

export function RoleHome() {
  const { user } = useAuth()
  if (!user) return null
  if (hasAnyPermission(user, ['users.view', 'catalog.manage', 'audit.view'])) return <Navigate replace to="/app/admin" />
  if (hasAnyPermission(user, ['requisitions.view_own', 'requisitions.view_all'])) return <Navigate replace to="/app/requisicoes" />
  if (hasAnyPermission(user, ['purchases.view'])) return <Navigate replace to="/app/compras" />
  return <Navigate replace to="/app/minha-conta" />
}

function AccessDenied() {
  const navigate = useNavigate()
  return (
    <main className="center-state">
      <LockKeyhole aria-hidden="true" />
      <h1>Acesso negado</h1>
      <p>Seu perfil não possui permissão para acessar esta área.</p>
      <button className="button button-secondary" type="button" onClick={() => navigate('/app')}>Voltar à área do perfil</button>
    </main>
  )
}
